
	<div class="header" [class.vertical]="vertical" [class.invislbe]="!hasLoaded" [class.noWebp]="noWebp">
		<div class="content" [ngsRevealSet]="{ reset:false, origin: 'bottom', scale:1, distance: '50px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
			<div class="contentInner">
				<div class="pageTitle">
				<h1 class="headline">The simple meeting room display</h1>
        <h2 class="tagline">Get the most out of your meeting and conference rooms and maximize collaboration with Dash, the simple meeting room display and booking system.</h2>
				<div class="storeButtonContainer">
				  <div>
            <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
            <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
          </div>
          <div>
            <a href="https://www.amazon.com/gp/product/B0D4DY15WY"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
            <a routerLink="/enterprise/web-app"><img ngSrc="../assets/images/web-badge.svg" width="133" height="40" alt="Available as a web app"></a>
          </div>
				</div>
				</div>
<!--				<div class="heroContainer" [ngsRevealSet]="{ reset:false, origin: 'right', scale:1, distance: '100px'}" [ngsInterval]="50" [ngsSelector]="'.hero'">-->
					<app-hero class="hero"></app-hero>
<!--				</div>-->
			</div>
		</div>
	</div>

  <div class="content tagContent" [class]="!hasLoaded? 'invisible' : null">
    <div class="contentInner">
      <div class="section tagSection">
        <h2 class="tagline">Dash has everything you need, and nothing you don't.</h2>
        <div class="tagRow">
          <div class="tagItem calendar"><div class="icon"></div>Uses your existing calendar system</div>
          <div class="tagItem noHardware"><div class="icon"></div>No proprietary hardware</div>
        </div>
        <div class="tagRow">
          <div class="tagItem fullyFeatured"><div class="icon"></div>Fully featured</div>
          <div class="tagItem padlock"><div class="icon"></div>We never see your meeting schedule</div>
        </div>
      </div>
    </div>
  </div>

	<div class="content" [class]="!hasLoaded? 'invisible' : null">
<!--		<div class="contentInner">-->


		<div class="section">
      <div class="sectionInner">
        <div class="section1">
          <h2 class="sectionHeader">Works with you</h2>
          <p>Dash works directly with Microsoft 365, Google Workspace, or the calendars on your phone or tablet.  Book from your desk with Outlook or Google Calendar; book from the room with your Dash display. </p>
          <p>We support any provider that you can display in the calendar app on your device.</p>
          <p><strong>Exchange or Microsoft 365?&nbsp;&nbsp;No problem!</strong></p>
          <p><strong>Google Workspace?&nbsp;&nbsp;Easy!</strong></p>
          <a class="button" routerLink="/features" fragment="calendar">Explore Dash's features</a>
        </div>
        <div class="spacer"></div>
        <div class="section2 image">
          <div class="pageImage worksWithYouImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage statusAtAGlanceImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2">
          <h2 class="sectionHeader">Status at a glance</h2>
          <p>Easily see whether a room is free, even from far away.  Up close, get a detailed schedule for the day so you always know what's on.</p>
          <p>Customize what is displayed on screen so that sensitive meeting names stay hidden.</p>
          <a class="button" routerLink="/features" fragment="display">Explore Dash's features</a>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1">
          <h2 class="sectionHeader">Booking made easy</h2>
          <p>Book a room in one touch, directly from the screen.</p>
          <p>Someone else got there first?  Find a free room close by so you don't have to go back to your desk.</p>
          <a class="button" routerLink="/features" fragment="booking">Explore Dash's features</a>
        </div>
        <div class="spacer"></div>
        <div class="section2 image">
          <div class="pageImage bookingMadeEasyImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage noMoreEmptyRoomsImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2">
          <h2 class="sectionHeader">No more wasted rooms</h2>
          <p>End a meeting early from the screen, so that the room is free in your schedule.</p>
          <p>You can require participants to check-in to a meeting when they arrive.  If noone has checked in ten minutes after the start time, Dash will end the meeting and make the room available.</p>
          <a class="button" routerLink="/features" fragment="booking">Explore Dash's features</a>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1">
          <h2 class="sectionHeader">Your brand in front</h2>
          <p>Your brand is important.  Dash makes it easy to customize colorschemes and imagery so that guests see your brand, not ours.</p>
          <p><strong>Beautiful.&nbsp;&nbsp;&nbsp;&nbsp;Professional.&nbsp;&nbsp;&nbsp;&nbsp;Easy.</strong></p>
          <a class="button" routerLink="/features" fragment="branding">Explore Dash's features</a>
        </div>
        <div class="spacer"></div>
        <div class="section2 image">
          <div class="pageImage brandingImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
      </div>
		</div>

    <div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage languageImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2">
          <h2 class="sectionHeader">In your language</h2>
          <p>Dash supports 25 languages, and times can be displayed in 12 or 24-hour format.</p>
          <p>We're always adding support for more languages, so if yours isn't supported yet please <a routerLink="/contact">contact us</a>.</p>
          <a class="button" routerLink="/guide/usingDash" fragment="languages">Supported languages</a>
        </div>
      </div>
    </div>

<!--		</div>-->
	</div>
	<div class="bottomSection" [class]="!hasLoaded? 'invisible' : null">
			<div class="content">
				<div class="contentInner">
					<div class="callToAction">
						<h2 class="sectionHeader">Get it now</h2>
						<p>Available for iOS and Android</p>
					</div>
					<div class="spacer" ></div>
					<div class="storeButtonContainer">
            <div>
              <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
              <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
            </div>
            <div>
              <a href="https://www.amazon.com/gp/product/B0D4DY15WY"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
              <a routerLink="/enterprise/web-app"><img ngSrc="../assets/images/web-badge.svg" width="133" height="40" alt="Available as a web app"></a>
            </div>
					</div>
				</div>
			</div>
	</div>

  <div class="loaderContainer" *ngIf="!hasLoaded">
    <div class="loader"></div>
    <img ngSrc="../assets/images/ipad-screen.webp" priority width="1" height="1" class="hiddenImage" (load)="countLoadedImage($event)" fetchpriority="high">
  </div>
